import { styled } from '@linaria/react';

/**
 * Shared styles for product section components
 */

export const SectionCard = styled.div`
    background: white;
    border-radius: 4px;
    padding: 1rem;
    border: 1px solid #e9ecef;
`;

export const SectionTitle = styled.h2`
    color: #333;
    margin: 0 0 1.5rem 0;
    font-size: 1.2rem;
    font-weight: 700;
    border-bottom: 1px solid #ccc;
    padding-bottom: 0.5rem;
`;

export const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.25rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const InfoItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 0.5rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #dee2e6;

    label {
        font-weight: 600;
        color: #495057;
        margin-right: 1rem;
        min-width: 120px;
        font-size: 0.9rem;
    }

    span {
        color: #333;
        text-align: right;
        flex: 1;
        word-break: break-word;
    }
`;

export const FullWidthInfoItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.3rem 0.5rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #dee2e6;
    grid-column: 1 / -1;

    label {
        font-weight: 600;
        color: #495057;
        margin: 0;
        font-size: 0.9rem;
    }

    > div {
        color: #333;
        word-break: break-word;
    }
`;

export const ProductNameField = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.3rem 0.5rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #dee2e6;
    grid-column: 1 / -1;

    label {
        font-weight: 600;
        color: #495057;
        margin: 0;
        font-size: 0.9rem;
        flex-shrink: 0;
    }

    > div {
        color: #333;
        word-break: break-word;
        flex: 1;
    }
`;

export const FullWidthFields = styled.div`
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const FullWidthItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #dee2e6;

    label {
        font-weight: 600;
        color: #495057;
        margin: 0;
        font-size: 0.9rem;
    }

    .full-width-content {
        color: #333;
        line-height: 1.5;
        word-break: break-word;

        pre {
            white-space: pre-wrap;
            margin: 0;
            font-family: inherit;
            background: transparent;
            border: none;
            padding: 0;
            color: #333;
        }
    }
`;

export const ScrollableContent = styled.div`
    max-height: 100px;
    overflow-y: auto;
    color: #333;
    line-height: 1.5;
    word-break: break-word;
    background: #fff;
`;

export const WarningBox = styled.div`
    margin-top: 1rem;
    padding: 0.75rem;
    background: #fff3cd;
    border: 2px solid #ffc107;
    border-radius: 4px;
    text-align: center;
    font-weight: bold;
    color: #856404;

    label {
        font-weight: 700;
        color: #856404;
        margin: 0 0 0.5rem 0;
        display: block;
    }

    pre {
        margin: 0;
        padding: 0;
        font-family: inherit;
        white-space: pre-wrap;
        word-break: break-word;
        background: transparent;
        border: none;
        font-weight: bold;
        text-align: center;
        color: #856404;
    }
`;

export const DocumentSection = styled.div`
`;

export const DocumentList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 1rem;
`;

export const DocumentItem = styled.div`
    display: flex;
    align-items: center;
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #007bff;

    label {
        font-weight: 600;
        color: #495057;
        margin: 0 1rem 0 0;
        min-width: 140px;
    }

    a {
        color: #007bff;
        text-decoration: none;
        word-break: break-all;
        
        &:hover {
            text-decoration: underline;
        }
    }
`;

export const DocumentSubSection = styled.div`
    margin-top: 1.5rem;

    h3 {
        font-size: 1rem;
        font-weight: 600;
        color: #495057;
        margin: 0 0 0.75rem 0;
    }
`;

export const ProcedureItem = styled.div`
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #007bff;

    label {
        font-weight: 600;
        color: #495057;
        margin: 0 0 0.5rem 0;
        display: block;
    }

    a {
        color: #007bff;
        text-decoration: none;
        
        &:hover {
            text-decoration: underline;
        }
    }

    pre {
        white-space: pre-wrap;
        margin: 0;
        font-family: inherit;
        background: transparent;
        border: none;
        padding: 0;
        color: #333;
    }

    strong {
        display: block;
        margin-top: 0.5rem;
    }
`;

export const UploadButton = styled.button`
    padding: 0.5rem 1rem;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 600;
    transition: background-color 0.2s;
    margin-top: 0.5rem;
    margin-bottom: 1rem;

    &:hover:not(:disabled) {
        background-color: #0056b3;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const HiddenFileInput = styled.input`
    display: none;
`;

export const DocumentActions = styled.div`
    display: flex;
    gap: 0.5rem;
    margin-left: auto;
`;

export const IconButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;
    background-color: transparent;

    &:hover:not(:disabled) {
        background-color: #e9ecef;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const DeleteButton = styled(IconButton)`
    color: #dc3545;

    &:hover:not(:disabled) {
        background-color: #f8d7da;
    }
`;

export const EditButton = styled(IconButton)`
    color: #0d6efd;

    &:hover:not(:disabled) {
        background-color: #cfe2ff;
    }
`;

export const RenameInput = styled.input`
    flex: 1;
    padding: 0.25rem 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 0.875rem;

    &:focus {
        outline: none;
        border-color: #86b7fe;
        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
    }
`;

export const RenameActions = styled.div`
    display: flex;
    gap: 0.25rem;
`;

export const ConfirmButton = styled(IconButton)`
    color: #198754;

    &:hover:not(:disabled) {
        background-color: #d1e7dd;
    }
`;

export const CancelButton = styled(IconButton)`
    color: #6c757d;

    &:hover:not(:disabled) {
        background-color: #e9ecef;
    }
`;
